import WebSocket from 'isomorphic-ws'
import config from '@/config'
import { getChatDomain } from '../utils/helpers'

let GATEWAY_LOCATION = ''
const hostName = getChatDomain()

if (hostName.includes('thermofisher') || hostName.includes('ampliseq')) {
  GATEWAY_LOCATION = config.THERMO_GATEWAY_LOCATION
} else if (hostName.includes('fishersci') || hostName.includes('punchout')) {
  GATEWAY_LOCATION = config.FISHER_GATEWAY_LOCATION
} else {
  GATEWAY_LOCATION = config.THERMO_GATEWAY_LOCATION
}

export function connectSocketApi () {
  return new WebSocket(
    (`${GATEWAY_LOCATION}/api/v1/session/chat`).replace('http', 'ws')
  )
}

// dummy commit 1
